/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Vekn_Merge_Swap_NoticeInputs */



/**
* | output |
* | --- |
* | "{name} has a VEKN ID, which can't be deleted, so this is the account that stays." |
*
* @param {Vekn_Merge_Swap_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merge_swap_notice = /** @type {((inputs: Vekn_Merge_Swap_NoticeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Merge_Swap_NoticeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} a un ID VEKN, qui ne peut pas être supprimé : c'est donc ce compte qui est conservé.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} tiene un ID VEKN, que no se puede borrar, así que es la cuenta que se conserva.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.name} tem um ID VEKN, que não pode ser excluído, então é esta a conta que fica.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} ha un ID VEKN, che non si può eliminare, quindi è questo l'account che resta.`)
	return /** @type {LocalizedString} */ (`${i?.name} has a VEKN ID, which can't be deleted, so this is the account that stays.`)
});